import angular from 'angular';
import emDataService from '../data/em.data.service';
import vmDataService from '../data/vm.data.service';
import ISharedModelService from './ISharedModel.service';

let _emDataService; // eslint-disable-line no-unused-vars
let _vmDataService; // eslint-disable-line no-unused-vars

class emSharedModelService extends ISharedModelService {
  constructor(
    emDataService, // eslint-disable-line no-shadow
    vmDataService, // eslint-disable-line no-shadow
  ) {
    super('em');
    _emDataService = emDataService;
    _vmDataService = vmDataService;

    console.log('app.services.emSharedModelService created');
  }

  /**
   * Create a new vendor with default values
   * @param {Object} [additionalProps] - key/value pairs with more default values
   * @returns {{vendorId: number, name: null}}
   */
  createNewVendor(additionalProps) {
    return {
      vendorId: -1,
      name: null,
      countryId: 1,
      ...additionalProps
    };
  }

  createNewProduct(additionalProps) {
    return {
      productId: -1,
      name: null,
      ...additionalProps
    };
  }

  /**
   *
   * @param functionObj
   * @return {int} - functionId
   */
  saveFunction(functionObj) {
    const key = `${functionObj.processId}${this.getHash(functionObj.name)}`;
    this.cache.em.functionName[key] = Promise.resolve(true);
    if (functionObj.functionId > -1) {
      return _emDataService.updateFunction(functionObj).then(response => response.data);
    }
    return _emDataService.addFunction(functionObj).then((response) => {
      // NOTE: Normally, the API will return the saved Function,
      // but for save a new function it is only returning the functionId
      // so we update the model and return it here.
      const functionId = response.data;
      functionObj.functionId = functionId;
      functionObj.canAddVendor = true;
      functionObj.canDeleteFunction = true;
      functionObj.canEditFunction = true;
      return functionObj;
    });
  }

  /**
   * Manages querying of names as the user types so we don't flood the API endpoint
   * @public
   * @async
   * @param functionId
   * @param name
   * @returns {Promise<boolean>} - Indicates if the name already exist
   */
  checkFunctionNameExists(processId, functionId, name) {
    const key = `${processId}${this.getHash(name)}`;
    if (!this.cache.em.functionName[key]) {
      this.cache.em.functionName[key] = _emDataService.checkFunctionExists(processId, functionId, name)
        .then(response => response.data.result);
    }
    return this.cache.em.functionName[key];
  }

  checkFunctionVendorNameExists(functionId, vendorId, name) {
   return _vmDataService.checkVendorExists(vendorId, name);
  }

  deleteFunction(functionObj) {
    return _emDataService.deleteFunction(functionObj.functionId).then(() => {
      const id = `${functionObj.processId}${this.getHash(functionObj.name)}`;
      this.cache.invalidate(this.cache.em.functionName, id);
    });
  }

  getFunction(functionId, forceRefresh = false) {
    if (forceRefresh || !this.cache.em.function[functionId]) {
      this.cache.em.function[functionId] = _emDataService.getFunction(functionId)
        .then(response => response.data);
    }
    return this.cache.em.function[functionId];
  }

  /**
   * Returns a Function object with default values, use to populate and save a new Function
   * @param processId
   * @return {*}
   */
  createNewFunction(processId) {
    return _emDataService.getFunction(0).then((response) => {
      const newFunctionObj = response.data;

      // NOTE: the API is returning 0 for processId and functionId, so we fix that here.
      newFunctionObj.processId = processId;
      newFunctionObj.functionId = -1;
      return newFunctionObj;
    });
  }
}

emSharedModelService.$inject = [
  'emDataService',
  'vmDataService',
];

export default angular.module('app.services.emSharedModelService', [
  emDataService,
  vmDataService,
])
  .service('emSharedModelService', emSharedModelService)
  .name;
